/* RESPONSIBLE TEAM: team-standalone */
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { EntityType } from 'embercom/models/data/entity-types';

export interface StandalonePlatformHandoffWireFormat {
  renderable_type: RenderableType;
  handoff_stage?: 'initiated' | 'completed';
  handoff_type: string;
  handoff_success?: boolean;
}

type HandoffStage = StandalonePlatformHandoffWireFormat['handoff_stage'];

export default class StandalonePlatformHandoff implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.StandalonePlatformHandoff;
  readonly handoffType: string;
  readonly handoffStage: HandoffStage;
  readonly handoffSuccess?: boolean;

  constructor(
    handoff_type: string,
    handoff_success: boolean | undefined,
    handoff_stage: HandoffStage,
  ) {
    this.handoffType = handoff_type;
    this.handoffStage = handoff_stage;
    this.handoffSuccess = handoff_success;
  }

  get adminOnly() {
    return true;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: StandalonePlatformHandoffWireFormat): StandalonePlatformHandoff {
    return new StandalonePlatformHandoff(
      json.handoff_type,
      json.handoff_success,
      json.handoff_stage,
    );
  }
}
